import {getCurrentInstance} from 'vue';
import {MetadataRecord} from '../../records/metadata.record';
import {SettingsRecord} from '../../records/settings.record';
import {UserRecord} from '../../records/user.record';
import {UISettingsRecord} from '../../records/ui-settings.record';

/**
 * App context.
 * Contains application-wide data.
 */
export type MaxoptraAppContext = {
    user?: UserRecord;
    locale?: string;
    language?: string;
    settings?: SettingsRecord;
    orderMetadata?: MetadataRecord[];
    uiSettings?: UISettingsRecord;
    dateFormats?: {
        date: string;
        time: string;
        datetime: string;
    };
    // localSettings: SettingsController; // TODO: add localSettings
};

const maxoptraAppContext: MaxoptraAppContext = {};

export function provideAppContext(context: MaxoptraAppContext) {
    Object.assign(maxoptraAppContext, context);
}

export function useAppContext(): MaxoptraAppContext {
    if (!getCurrentInstance()) {
        // console.debug('useAppContext() should be called in setup()');
    }
    return maxoptraAppContext;
}
